
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
@Component({
    selector: 'tag',
    styleUrls: ['./tag.component.scss'],
    template: `
        <button class="btn btn-secondary">{{code}}@if (removeable) {
          <span class="remove">x</span>
        }</button>
        `,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class TagComponent {
	@Input() public code: string;
	@Input() public removeable: boolean = true;
}
